<template>
	<div class="edit-product">
		<NavBar v-if="admin" :admin="true" :items="items" />
		<Breadcrumbs v-else :items="items" />
		<v-main :class="admin ? 'mx-12' : 'pa-0'">
			<v-progress-linear indeterminate color="primary" v-if="!loaded"></v-progress-linear>
			<ProductForm
				v-if="loaded"
				:product="product"
				:providers="providers"
				:productUnits="productUnits"
				:substanceTypes="substanceTypes"
				:plantParts="plantParts"
				:productStorages="productStorages"
				:productPresentations="productPresentations"
				:productProcessing="productProcessing"
				:drugInteractions="drugInteractions"
				:edit="true"
				:admin="admin"
			/>
		</v-main>
	</div>
</template>

<script>
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import NavBar from "@/components/authentication/NavBar.vue";
import ProductForm from "@/components/products/ProductForm.vue";
import axios from "axios";

export default {
	name: "EditProduct",
	components: {
		Breadcrumbs,
		NavBar,
		ProductForm
	},
	data: () => ({
		product: {
			ingredients: [],
			indications_icd: [],
			contraindications_icd: [],
			information: {"pt":{}}
		},
		providers: [],
		productUnits: [],
		substanceTypes: [],
		plantParts: [],
		productStorages: [],
		productPresentations: [],
		productProcessing: [],
		drugInteractions: [],
		loaded: false
	}),
	computed: {
		admin() {
			return this.$store.getters.hasRole('admin');
		},
		isExternalEntity() {
			return this.$store.getters.isExternalEntity;
		},
		items() {
			return [
				... this.admin || !this.isExternalEntity ? [{
						text: this.$gettext("Dashboard"),
						disabled: false,
						link: true,
						to: this.admin ? { name: "dashboard" } : { name: "home" }
					}] : [],
				... !this.admin && !this.isExternalEntity ? [{
						text: this.$gettext("Treatments"),
						disabled: false,
						link: true,
						to: { name: "treatments" }
					}] : [],
				{
					text: this.$gettext("Supplements"),
					disabled: false,
					link: true,
					to: this.admin ? { name: "admin-supplements", params: { admin: true } } : { name: "supplements" }
				},
				{
					name: true,
					text: this.product.name ?? this.product.information.pt.name,
					disabled: true,
					link: true
				},
				{
					text: this.$gettext("Edit"),
					disabled: true,
					link: true
				}
			]
		}
	},
	created() {
		const productId = this.$route.params.sid;
		axios
			.get("/product/" + productId + "/edit")
			.then(response => {
				console.log(response.data);
				this.product = response.data.product;
				this.providers = response.data.providers;
				this.providers.push({ id: -1, name: this.$gettext("Create Provider...") });
				this.productUnits = response.data.product_units;
				this.substanceTypes = response.data.substance_types;
				this.plantParts = response.data.plant_parts;
				this.productStorages = response.data.product_storages;
				this.productPresentations = response.data.product_presentations;
				this.productProcessing = response.data.product_processing;
				this.drugInteractions = response.data.medicine_interactions;
				this.loaded = true;
			})
			.catch(error => {
				console.log(error);
			});
	}
};
</script>